export default {
  title: "تصنيفات المنتجات",
  subtitle: "إدارة تصنيفات المنتجات",
  
  // Actions
  addNew: "إضافة تصنيف جديد",
  createCategory: "إنشاء تصنيف",
  editCategory: "تعديل التصنيف",
  deleteCategory: "حذف التصنيف",

  actions: {
    back: "رجوع",
    update: "تحديث",
    updating: "جاري التحديث...",
    save: "حفظ",
    saving: "جاري الحفظ...",
    cancel: "إلغاء",
    edit: "تعديل",
    delete: "حذف"
  },
  
  // Fields
  fields: {
    name: "اسم التصنيف",
    hsCode: "الكود الجمركي",
    description: "الوصف",
    tax: "نسبة الضريبة",
    status: "الحالة",
    createdAt: "تاريخ الإنشاء",
    updatedAt: "تاريخ التحديث"
  },
  
  // Placeholders
  placeholders: {
    name: "أدخل اسم التصنيف",
    hsCode: "أدخل الكود الجمركي",
    description: "أدخل وصف التصنيف",
    tax: "أدخل نسبة الضريبة"
  },
  
  // Messages
  messages: {
    createSuccess: "تم إنشاء التصنيف بنجاح",
    createError: "فشل في إنشاء التصنيف",
    updateSuccess: "تم تحديث التصنيف بنجاح",
    updateError: "فشل في تحديث التصنيف",
    deleteSuccess: "تم حذف التصنيف بنجاح",
    deleteError: "فشل في حذف التصنيف",
    deleteConfirm: "هل أنت متأكد من حذف هذا التصنيف؟",
    noCategories: "لا يوجد تصنيف",
    loadingCategories: "جاري تحميل التصنيفات...",
    fetchError: "فشل في جلب التصنيفات"
  },
  
  // Validation
  validation: {
    nameRequired: "اسم التصنيف مطلوب",
    nameMinLength: "اسم التصنيف يجب أن يكون على الأقل حرفين",
    nameMaxLength: "اسم التصنيف يجب ألا يتجاوز 100 حرف",
    hsCodeRequired: " مطلوب الكود الجمركي",
    hsCodeFormat: "الكود الجمركي يجب أن يكون بصيغة صحيحة",
    taxRequired: "نسبة الضريبة مطلوبة",
    taxMin: "نسبة الضريبة يجب أن يكون 0 أو أكثر",
    taxMax: "نسبة الضريبة يجب ألا يتجاوز 100",
    descriptionMaxLength: "الوصف يجب ألا يتجاوز 500 حرف"
  },
  
  // Table headers
  table: {
    name: "الاسم",
    hsCode: "الكود الجمركي",
    description: "الوصف",
    tax: "نسبة الضريبة",
    status: "الحالة",
    actions: "خيارات الأوامر"
  },
  
  // Status options
  statusOptions: {
    active: "نشط",
    inactive: "غير نشط"
  },
  
  // Breadcrumbs
  breadcrumbs: {
    categories: "التصنيفات",
    create: "إنشاء تصنيف",
    edit: "تعديل التصنيف",
    view: "عرض التصنيف"
  }
};
